import { Injectable } from '@angular/core';
import { LytxWindow } from '@lytx/platform.ui.components';
import jwt_decode from 'jwt-decode';

@Injectable()
export class SessionService {
  private currentSession: Session;

  constructor(private window: LytxWindow) {
    const sessionAsString: string = this.window.localStorage.getItem('session');

    if (sessionAsString) {
      const session: Session = JSON.parse(sessionAsString);
      const { token, name, email, groups } = session;

      if (!this.tokenIsExpired(token)) {
        const userGroups = groups as string[];
        this.initializeSession(token, name, email, userGroups);
      }
    }
  }

  initializeSession(
    token: string,
    name: string,
    email: string,
    groups: string[],
  ): Session {
    this.currentSession = {
      token: token,
      name: name,
      email: email,
      groups: groups,
    };

    this.window.localStorage.setItem(
      'session',
      JSON.stringify(this.currentSession),
    );

    return this.currentSession;
  }

  getCurrentSession(): Session {
    return this.currentSession;
  }

  getToken(): string {
    if (this.currentSession) {
      return this.currentSession.token;
    }

    return undefined;
  }

  clearSession(): void {
    this.currentSession = undefined;
    this.window.localStorage.clear();
  }

  tokenIsExpired(token = this.currentSession.token): boolean {
    const expirationTime = jwt_decode(token)['exp'];

    return expirationTime < new Date().getTime() / 1000;
  }
}

export interface Session {
  token: string;
  name: string;
  email: string;
  groups: string[];
}
